import { render, staticRenderFns } from "./ModalProjectContacts.vue?vue&type=template&id=0a2dfbaf&lang=pug&"
import script from "./ModalProjectContacts.vue?vue&type=script&lang=js&"
export * from "./ModalProjectContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports